import React from 'react';

/**
 * Empty state for chat view
 * Shows when no conversation is selected
 */
const EmptyChatView: React.FC = () => {
  return (
    <div className="flex flex-col w-full h-full bg-gradient-to-b from-[#FAFBFC] to-[#F3F4F6]">
      {/* Centered empty state */}
      <div className="flex-1 flex flex-col items-center justify-center">
        <div className="flex flex-col items-center gap-4 px-6">
          {/* Illustration */}
          <div className="w-24 h-24 rounded-2xl bg-gradient-to-br from-[#015FA6]/10 to-[#015FA6]/5 flex items-center justify-center mb-2">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M21 15C21 15.5304 20.7893 16.0391 20.4142 16.4142C20.0391 16.7893 19.5304 17 19 17H7L3 21V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V15Z"
                stroke="#015FA6"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <circle cx="8" cy="10" r="1" fill="#015FA6"/>
              <circle cx="12" cy="10" r="1" fill="#015FA6"/>
              <circle cx="16" cy="10" r="1" fill="#015FA6"/>
            </svg>
          </div>

          {/* Text */}
          <div className="text-center">
            <p className="font-manrope font-semibold text-lg text-[#374151]">
              Select a conversation
            </p>
            <p className="font-manrope font-normal text-sm text-[#9CA3AF] mt-1 max-w-[280px]">
              Choose a conversation from the list to start messaging
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmptyChatView;
